import * as Yup from 'yup'

import { ASSUMPTION_NAME, ASSUMPTIONS, STAKEHOLDER_TYPE, STAKEHOLDERS_LIST } from './fields'

export const validationSchema = Yup.object({
  [ASSUMPTIONS]: Yup.array().of(
    Yup.object({
      [ASSUMPTION_NAME]: Yup.string().required('Assumption Name Required')
    })
  ),
  [STAKEHOLDERS_LIST]: Yup.array().of(
    Yup.object({
      [STAKEHOLDER_TYPE]: Yup.string().required('Stakeholder Type Required')
    })
  )
})
